/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard/index.jsx";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import TopNavLargeButton from "../../../../components/_utils/CommonButtons/TopNavLargeButton/index.jsx";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import CommonInfoBox from "../../../../components/_utils/CommonInfoBox/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index.js";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup";
import RecreatePromptModalPopup from "../../../../components/_utils/RecreatePromptModalPopup/index.jsx";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar/index.jsx";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent/index.jsx";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair/index.jsx";
import InternalTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/InternalTxnDeclinePopup.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import InternalAccountDetailsPopup from "../../../../components/Accounts/InternalAccount/InternalAccountDetailsPopup/index.jsx";
import OwnerAccountDetailsPopUp from "../../../../components/Accounts/OwnerAccount/OwnerAccountDetailsPopUp/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  internalTransactionsActionable,
  internalTransactionsAddLabel,
  internalTransactionsApprove,
  internalTransactionsDetailsById,
  internalTransactionsReject,
  internalTransactionsRemoveLabel,
  updateInternalTxnDetailData,
} from "../../../../redux/features/transactions/internalTransactions/index.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
} from "../../../../utils/configurationProvider.js";
import formatCurrency from "../../../../utils/CurrencyFormater.js";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import globalText from "../../../../utils/globalText.js";
import ISO_DataFormatter from "../../../../utils/ISO_DataFormatter.js";
import "./index.css";
import InternalTransactionViewAllPopup from "../../../../components/Transactions/InternalTransaction/InternalTransactionViewAllPopup/index.jsx";
const InternalTransactionDetails = ({
  internal_txn_id,
  closeInternalTxnDetailModal,
  type,
  error_msg,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locationState = useLocation();
  const previousStatus = useLocation()?.state?.options?.state;
  const { id } = useParams();

  const cardRefs = useRef({});
  const cardRefsDist = useRef({});
  const leftContentRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const isPopup = type === "internal_txn_detail_modal";
  const [showRecreatePopup, setShowRecreatePopup] = useState(false);
  const [showDetails, setShowDetails] = useState(!isPopup);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(isPopup);
  const [showLabel, setShowLabel] = useState(false);
  const [infoBox, setInfoBox] = useState(false);
  const [viewInternalTxnDetails, setViewInternalTxnDetails] = useState();

  const [loading, setLoading] = useState(true);

  const [copiedField, setCopiedField] = useState("");
  const [openTransHistory, setOpenTransHistory] = useState(false);

  const [loadingBox, setLoadingBox] = useState(false);
  const [internalTxnDetailID, setInternalTxnDetailID] = useState("");
  const [internalAccountID, setInternalAccountID] = useState("");
  const [approvalNotPermitted, setApprovalNotPermitted] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [showDistributionTimeline, setShowDistributionTimeline] =
    useState(false);
  const [networkError, setNetworkError] = useState(false);
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState(error_msg ? error_msg : "");
  const [entityId, setEntityId] = useState("");
  const [checkInternalTransaction, setCheckInternalTransaction] =
    useState(false);
  const [internalAccountDetailpop, setInternalAccountDetailpop] =
    useState(false);
  const [modalType, setModalType] = useState("");
  const [labelDetails, setLabelDetails] = useState([]);
  const [labels, setLabels] = useState([]);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [btnClicked, setbtnClicked] = useState({});

  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [, setRightHeight] = useState("auto");
  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});

  const [index, setIndex] = useState(
    showDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showAdditionalDetails
        ? GlobalConfiguration?.lengthCheckOne
        : showLabel
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );

  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);

  const resetAllTimelines = () => {
    setOpenApprovalTimeline(
      new Array(
        viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.logs
          ?.length || GlobalConfiguration.lengthCheckZero,
      ).fill(false),
    );
    setOpenDistributionTimeline(
      new Array(
        viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
          ?.distribution_logs?.length || GlobalConfiguration.lengthCheckZero,
      ).fill(false),
    );
  };
  const [animationClass, setAnimationClass] = useState("");
  const [ownerDetailpop, setOwnerDetailpop] = useState(false);
  const [internalAccDetailOpen, setInternalAccDetailOpen] = useState(false);

  const { services } = useSelector((state) => state.refreshToken);
  const {
    internalTransactionsDetailsDataLoading,
    internalTransactionsDetailsData,
  } = useSelector((state) => state.internalTransactions);

  const rejectedTnx =
    viewInternalTxnDetails?.[0]?.lifecycle_status === "rejected";

  const isOutsideBankingHoursNow = isOutsideBankingHours();

  const hasApprovalService = services?.includes("AInternalTxn");

  const isTransactionPendingOutsideBankingHours =
    hasApprovalService &&
    viewInternalTxnDetails?.[0]?.lifecycle_status === "pending" &&
    isOutsideBankingHoursNow;

  const isAccountApprovalPendingOutsideBankingHours =
    hasApprovalService &&
    viewInternalTxnDetails?.[0]?.internal_account_approval_status ===
      "pending" &&
    isOutsideBankingHoursNow;

  const shouldShowBankingHoursAlert =
    isTransactionPendingOutsideBankingHours ||
    isAccountApprovalPendingOutsideBankingHours;

  const hasConfidential = services?.includes("VConfidentialTxn");
  const loginid = JSON.parse(sessionStorage.getItem("response"));
  const hasCreateService = services?.includes("CInternalTxn");

  const isRejectedOrServiceMissing =
    rejectedTnx || !services?.includes("AInternalTxn");

  const isPendingInternalTxn =
    checkInternalTransaction &&
    internalTransactionsDetailsData?.transaction?.[
      GlobalConfiguration.lengthCheckZero
    ]?.lifecycle_status === "pending";

  const isFurtherApprovalPending =
    (viewInternalTxnDetails?.[0]?.last_updated_status === "Approved" &&
      viewInternalTxnDetails?.[0]?.lifecycle_status === "pending" &&
      viewInternalTxnDetails?.[0]?.last_updated_user_id ===
        loginid?.employees?.id) ||
    (viewInternalTxnDetails?.[0]?.last_updated_status === "Approved" &&
      viewInternalTxnDetails?.[0]?.lifecycle_status === "pending" &&
      services?.find((service) => service === "AInternalTxn") === undefined);

  const handleRecreateDeclinedDetails = (id) => {
    setInternalTxnDetailID(id);
    setShowRecreatePopup(true);
  };

  const fetchData = async () => {
    if (internalTransactionsDetailsDataLoading) {
      setLoading(true);
    }
    try {
      let response;

      if (isPopup) {
        response = await dispatch(
          internalTransactionsDetailsById({
            id: internal_txn_id,
          }),
        );

        if (internalTransactionsDetailsById.fulfilled.match(response)) {
          setLabelDetails(
            response?.payload?.transaction?.[
              GlobalConfiguration.lengthCheckZero
            ]?.labels || [],
          );
        }
      } else {
        response = await dispatch(
          internalTransactionsDetailsById({
            id,
          }),
        );

        if (internalTransactionsDetailsById.fulfilled.match(response)) {
          setLabelDetails(
            response?.payload?.transaction?.[
              GlobalConfiguration.lengthCheckZero
            ]?.labels || [],
          );
        }
      }
      if (
        response?.payload?.status === errorcode.errorNotFound ||
        response?.payload?.status === errorcode.errorUnAuthorized
      ) {
        navigate("/*");
        return;
      }
    } catch (error) {
      console.error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
  };

  const openTransactionHistory = () => {
    setOpenTransHistory(true);
  };

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
  };

  const handleDeclinedDetails = (id) => {
    setInternalTxnDetailID(id);
    setShowDeclineModal(true);
  };

  const closeDeclineModal = (id) => {
    setShowDeclineModal(false);
    setbtnClicked(() => ({
      // ...prev,
      [internalTransactionsDetailsData.txn_id]: "none",
    }));
  };

  const closeBeneAccountDetailModal = () => {
    setInternalAccountDetailpop(false);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setViewInternalTxnDetails(updatedAccounts);
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setOpenDistributionTimeline(
      Array(
        viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
          ?.distribution_logs?.length,
      ).fill(false),
    );
    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const handleDistributionTimeline = (index) => {
    setOpenDistributionTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setTimeout(() => {
      if (cardRefsDist.current[index]) {
        cardRefsDist.current[index].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, IntervalConfiguration.intervalExtraSmall);
  };

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${internal_txn_id}`,
    });
  };

  const handleDistributionClick = () => {
    SetopenTimelinePopup(true);
    setShowDistributionTimeline(true);
    if (!showDistributionTimeline) {
      setShowDetails(true);
      setShowAdditionalDetails(false);
      setShowApprovalTimeline(false);
      setShowLabel(false);
    }
    setOpenApprovalTimeline(false);
  };

  const additionalData =
    internalTransactionsDetailsData?.transaction?.[
      GlobalConfiguration.lengthCheckZero
    ]?.additional_data;

  const validItems = additionalData?.data ? additionalData?.data : [];

  const attachments = validItems.filter(
    (obj) =>
      (obj.data_type.toLowerCase() === "hyperlink" ||
        obj.data_type === "File" ||
        obj.data_type === "upload") &&
      "value" in obj,
  );

  const showAmountInfo = (e) => {
    setInfoBox(!infoBox);
  };
  const closeModal = () => {
    if (infoBox) {
      setInfoBox(false);
    }
  };

  const toggleDetails = () => {
    setShowDetails(true);
    setShowAdditionalDetails(false);
    setShowLabel(false);
  };

  const toggleLabels = () => {
    setShowLabel(true);
    setShowDetails(false);
    setShowAdditionalDetails(false);
  };

  const toggleAdditionalDetails = () => {
    setShowAdditionalDetails(true);
    setShowDetails(false);
    setShowLabel(false);
  };

  const handleApproveInternalTransaction = async (id) => {
    setbtnClicked((prev) => ({
      ...prev,
      [id]: "Approve",
    }));
    UniversalRefreshToast("Approving transaction");

    setTimeout(() => {
      toast.dismiss();
    }, IntervalConfiguration?.intervalMedium);
    let res;
    if (isPopup) {
      res = await dispatch(
        internalTransactionsApprove({ id: internal_txn_id }),
      );
    } else {
      res = await dispatch(internalTransactionsApprove({ id }));
    }
    if (res?.payload === undefined) {
      setNetworkError(
        "An error occured while taking action on this transaction",
      );
      setTimeout(() => {
        CommonToast({
          text: "An error occured while taking action on this transaction",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      }, IntervalConfiguration?.intervalExtraLarge);
    } else if (
      res?.payload?.errors?.user_unauthorized?.[
        GlobalConfiguration.lengthCheckZero
      ]
    ) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "VBeneficiaryTxn",
          },
        });
      }, IntervalConfiguration?.intervalExtraLarge);
    } else if (
      res?.payload?.status === false ||
      res.type === "internalTransactionsReject/rejected"
    ) {
      if (
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ?.errors &&
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ?.errors?.[GlobalConfiguration.lengthCheckZero]?.reason
      ) {
        const errorMsg =
          res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
            ?.errors?.[GlobalConfiguration.lengthCheckZero]?.reason;
        if (!Array.isArray(errorMsg)) {
          setErrorMessage(errorMsg);
          setTimeout(() => {
            CommonToast({
              text: errorMsg,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
            });
          }, IntervalConfiguration?.intervalMedium);
        } else {
          setErrorMessage(
            res.payload.errors.base?.[GlobalConfiguration.lengthCheckZero]
              .errors?.[GlobalConfiguration.lengthCheckZero].reason?.[
              GlobalConfiguration.lengthCheckZero
            ],
          );
          if (
            res.payload.errors.base?.[GlobalConfiguration.lengthCheckZero]
              .errors?.[GlobalConfiguration.lengthCheckZero].reason.length >=
            GlobalConfiguration?.lengthCheckOne
          ) {
            let msgs =
              res.payload.errors.base?.[GlobalConfiguration.lengthCheckZero]
                .errors?.[GlobalConfiguration.lengthCheckZero].reason;
            msgs.forEach((error) => {
              if (res?.payload?.status === false) {
                setTimeout(() => {
                  CommonToast({
                    text: error,
                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                    variant: "var(--error)",
                  });
                }, IntervalConfiguration?.intervalMedium);
              }
            });
          }
        }
      } else if (
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ?.reason &&
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ?.reason?.[GlobalConfiguration.lengthCheckZero]
      ) {
        setErrorMessage(
          res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
            ?.reason?.[GlobalConfiguration.lengthCheckZero],
        );
        setTimeout(() => {
          CommonToast({
            text: res?.payload?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ]?.reason?.[GlobalConfiguration.lengthCheckZero],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        }, IntervalConfiguration?.intervalMedium);
      } else if (
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
      ) {
        setErrorMessage(
          res.payload.errors.base?.[GlobalConfiguration.lengthCheckZero],
        );
        setTimeout(() => {
          CommonToast({
            text: res.payload.errors.base?.[
              GlobalConfiguration.lengthCheckZero
            ],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        }, IntervalConfiguration?.intervalExtraLarge);
      }
    } else {
      const approvedLifecycle =
        res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
          ?.lifecycle_status;
      const approvedDistributionFromRes =
        res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
          ?.distribution_lifecycle_status;

      const approvedDistribution =
        approvedDistributionFromRes ??
        (approvedLifecycle === "approved" ? "created" : undefined);
      const updatedData = internalTransactionsDetailsData?.transaction?.map(
        (data) => {
          const resolvedLifecycle = approvedLifecycle ?? data?.lifecycle_status;
          const resolvedDistribution =
            approvedDistribution ?? data?.distribution_lifecycle_status;

          const uiState = addLifeCycleStatus({
            lifecycle_status: resolvedLifecycle,
            distribution_lifecycle_status: resolvedDistribution,
            services,
          });

          return {
            ...data,
            lifecycle_status: resolvedLifecycle,
            distribution_lifecycle_status: resolvedDistribution,
            last_updated_status:
              res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
                ?.last_updated_status,
            last_updated_user_id:
              res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
                ?.last_updated_user_id,
            ...uiState,
          };
        },
      );
      setViewInternalTxnDetails(updatedData);

      if (isPopup) {
        let data = structuredClone(res?.payload);
        delete data.transactions;
        data.transaction = res?.payload?.transactions;
        await dispatch(updateInternalTxnDetailData(data));
      } else {
        let data = structuredClone(res?.payload);
        delete data.transactions;
        data.transaction = res?.payload?.transactions;
        await dispatch(updateInternalTxnDetailData(data));
      }
      if (res?.payload?.status === true) {
        if (
          isPopup ||
          locationState?.state?.type === "Internal-Multi-Approval-Txn-Details"
        ) {
          let getSessionData = JSON.parse(
            sessionStorage.getItem("selectedData"),
          );

          let selectedSendTransactions =
            getSessionData?.selectedSendTransactions?.filter(
              (fil) => fil.txn_id !== id,
            );
          let selectedTransactions =
            getSessionData?.selectedTransactions?.filter((fil) => fil !== id);
          sessionStorage.setItem(
            "selectedData",
            JSON.stringify({
              selectedSendTransactions: selectedSendTransactions,
              selectedTransactions: selectedTransactions,
            }),
          );
          if (
            locationState?.state?.type === "Internal-Multi-Approval-Txn-Details"
          ) {
            if (
              selectedSendTransactions?.length ===
                GlobalConfiguration?.lengthCheckZero &&
              selectedTransactions?.length ===
                GlobalConfiguration?.lengthCheckZero
            ) {
              navigate(
                `/internal_transaction_dashboard/internal_transaction_multi_approval`,
              );
            } else {
              navigate(GlobalConfiguration?.navigate_back);
            }
          }
        }

        CommonToast({
          text: "Transaction approved successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
      }
      if (isPopup) {
        setTimeout(() => {
          // closeInternalTxnDetailModal();
          window.location.reload();
        }, IntervalConfiguration?.intervalTiny);
      }
    }
  };

  const handleRecreateConfirmation = (reason) => {
    (async () => {
      setLoadingBox(true);
      const response = await dispatch(
        internalTransactionsReject({
          id: internalTxnDetailID || id || internal_txn_id,
          rejection_reason: reason,
        }),
      );
      if (internalTransactionsReject.fulfilled.match(response)) {
        CommonToast({
          text: "Transaction rejected and sent for recreation.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
        await fetchData();
        setNetworkError(null);
        setErrorMessage(null);
        setShowRecreatePopup(false);
      } else {
        if (
          response?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
            ?.errors
        ) {
          const errors =
            response.payload.errors.base[GlobalConfiguration.lengthCheckZero]
              .errors;

          if (errors.length >= GlobalConfiguration.lengthCheckOne) {
            errors.forEach((error) => {
              CommonToast({
                text: error,
                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            });
          } else {
            CommonToast({
              text: errors[GlobalConfiguration.lengthCheckZero],
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }
        } else if (
          response?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
        ) {
          CommonToast({
            text: response.payload.errors.base[
              GlobalConfiguration.lengthCheckZero
            ],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
        setShowRecreatePopup(false);
      }
      setLoadingBox(false);
    })();
  };

  const handleTimelinePopup = () => {
    if (isPopup) {
      actionRestricted();
      return;
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
      if (!showApprovalTimeline) {
        setShowDetails(true);
        setShowAdditionalDetails(false);
        setShowDistributionTimeline(false);
        setShowLabel(false);
      }
      setOpenDistributionTimeline(false);
    }
  };

  const handleClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    fetchData();
  };

  const labelTxnIds = [internalTxnDetailID || id || internal_txn_id].filter(
    Boolean,
  );

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnIds);
    const res = await dispatch(
      internalTransactionsAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (internalTransactionsAddLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (internalTransactionsAddLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    setLabelPopupLoading(false);
    if (internalTransactionsAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnIds);
    const res = await dispatch(
      internalTransactionsRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (internalTransactionsRemoveLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (internalTransactionsRemoveLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    setLabelPopupLoading(false);
    if (internalTransactionsRemoveLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const PopupcloseIcons = () => {
    resetAllTimelines();
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
    setShowDistributionTimeline(false);
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("internalTxnLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(disableSwitcher());
    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
  }, []);
  useEffect(() => {
    const updateHeight = () => {
      setRightHeight(leftContentRef?.current?.offsetHeight);
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [viewInternalTxnDetails]);
  useEffect(() => {
    if (internalTransactionsDetailsData) {
      const uiState = addLifeCycleStatus({
        lifecycle_status:
          internalTransactionsDetailsData?.transaction[
            GlobalConfiguration.lengthCheckZero
          ]?.lifecycle_status,
        distribution_lifecycle_status:
          internalTransactionsDetailsData?.transaction[
            GlobalConfiguration.lengthCheckZero
          ]?.distribution_lifecycle_status,
        services,
        previousStatus: previousStatus,
      });
      const newData = internalTransactionsDetailsData?.transaction?.map(
        (account) => ({
          ...account,
          loading: false,
          error: false,
          message: "",
          last_updated_user_id_check: false,
          ...uiState,
        }),
      );
      setViewInternalTxnDetails(newData);
      setEntityId(
        internalTransactionsDetailsData?.transaction?.[
          GlobalConfiguration.lengthCheckZero
        ]?.entity_id,
      );
      setInternalTxnDetailID(
        internalTransactionsDetailsData?.transaction?.[
          GlobalConfiguration.lengthCheckZero
        ]?.txn_id,
      );
      setInternalAccountID(
        internalTransactionsDetailsData?.transaction?.[
          GlobalConfiguration.lengthCheckZero
        ]?.internal_account_id,
      );
    }
  }, [internalTransactionsDetailsData]);

  useEffect(() => {
    const targetId = id ?? internal_txn_id;

    const checkTxnActionable = async () => {
      if (!entityId || !internalTxnDetailID) return;
      if (targetId && internalTxnDetailID !== targetId) return;

      const isPendingWithApprovalService =
        internalTransactionsDetailsData?.transaction?.[
          GlobalConfiguration.lengthCheckZero
        ]?.lifecycle_status === "pending" && services?.includes("AInternalTxn");

      if (!isPendingWithApprovalService) {
        setCheckInternalTransaction(false);
        return;
      }

      setLoadingBox(true);
      try {
        const response = await dispatch(
          internalTransactionsActionable({
            entityId: entityId,
            txn_id: [internalTxnDetailID],
          }),
        );

        const transactionsData = response?.payload?.transactions || [];

        if (transactionsData.length === 0) {
          setCheckInternalTransaction(false);
          setApprovalNotPermitted(true);
          return;
        }

        const transactionExists = transactionsData.some(
          (obj) => obj.txn_id === internalTxnDetailID,
        );
        setCheckInternalTransaction(transactionExists);
      } catch (error) {
        setCheckInternalTransaction(false);
      } finally {
        setLoadingBox(false);
      }
    };

    checkTxnActionable();
  }, [
    dispatch,
    entityId,
    internalTxnDetailID,
    internalTransactionsDetailsData?.transaction?.[
      GlobalConfiguration.lengthCheckZero
    ]?.lifecycle_status,
    services,
    id,
    internal_txn_id,
  ]);

  useEffect(() => {
    setInternalTxnDetailID("");
    setCheckInternalTransaction(false);
    setApprovalNotPermitted(false);
  }, [id, internal_txn_id]);
  const txn =
    internalTransactionsDetailsData?.transaction?.[
      GlobalConfiguration.lengthCheckZero
    ];
  return (
    <>
      <>{RestrictedActionPopup}</>

      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnIds}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={(internalTransactionsDetailsData?.transaction || [])
              ?.filter((t) => labelTxnIds.includes(t.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {openImageUrl && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <MediumImagePopup
              image={selectedImage}
              closehandleFunction={() => {
                setOpenImageUrl(false);
              }}
            />
          </div>
        </>
      )}
      {ownerDetailpop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
          <OwnerAccountDetailsPopUp
            closeBeneAccountDetailModal={() => {
              setOwnerDetailpop(false);
            }}
            Remibursement_owneraccount_id={
              internalTransactionsDetailsData?.transaction?.[0]
                ?.owner_account_id
            }
            type={"reimburseowner_details"}
          />
        </div>
      )}
      {internalAccDetailOpen ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalAccountDetailsPopup
            closeBeneAccountDetailModal={() => setInternalAccDetailOpen(false)}
            bene_account_id={
              internalTransactionsDetailsData?.transaction?.[0]
                ?.internal_account_id
            }
            type={"bene_account_detail_modal"}
            internalAccDetailOpen={internalAccDetailOpen}
            openTransHistory={openTransHistory}
          />
        </div>
      ) : null}
      {opentimelinepopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Transaction timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              handleFunction={() => {}}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={viewInternalTxnDetails}
                handleApprovalClick={handleTimelinePopup}
                handleDistributionClick={handleDistributionClick}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                showDistributionTimeline={showDistributionTimeline}
                openDistributionTimeline={openDistributionTimeline}
                handleDistributionTimeline={handleDistributionTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"double"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {showRecreatePopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <RecreatePromptModalPopup
            onConfirmBtnClick={handleRecreateConfirmation}
            onClose={() => {
              setShowRecreatePopup(false);
            }}
            onCancelBtnClick={() => {
              setShowRecreatePopup(false);
            }}
          />
        </div>
      )}
      <div
        className="bg-primary-bg overflow-x-hidden"
        style={{
          height: isPopup ? "var(--height-full)" : "var(--full-height)",
          overflowY: openTransHistory ? "hidden" : "auto",
        }}
        onClick={closeModal}
      >
        {loading ? (
          <div className="fixed inset-0 flex  items-center justify-center m-auto ">
            <Loader />
          </div>
        ) : (
          <>
            {!isPopup && (
              <div className="Qsmd:flex hidden h-fixed-header mt-margin-lg bg-primary-nav w-width-full" />
            )}

            <div
              className={`bg-primary-nav w-full h-auto block ${isPopup ? "" : "Qmd:mt-margin-base"}`}
            >
              <div
                className={`bg-primary-nav shadow-box-shadow-bottom fixed top-top-base left-left-base z-z-index-tooltip w-width-full block ${
                  isPopup ? "hidden" : "lg:hidden"
                }`}
              >
                <TopNavComponent
                  topNavHeader={globalText?.INTERNAL}
                  topNavSubText={globalText?.TRANSACTION_DETAILS}
                  isFormattingNotRequired
                />
              </div>

              {openTransHistory && (
                <InternalTransactionViewAllPopup
                  isOpen={openTransHistory}
                  onClose={closeTransactionHistory}
                  title={
                    modalType === "Confidential transaction"
                      ? "Confidential transaction"
                      : "Transaction history"
                  }
                  subtitle={
                    modalType === "Confidential transaction"
                      ? "All confidential transactions related to the destination account and source account are listed below."
                      : "All transactions related to the destination account and source account are listed below."
                  }
                  contentProps={{
                    txnHistorytype: "internalTxnHistory",
                    typepop: modalType,
                    loading,
                    setLoading,
                    openTransHistory,
                    setOpenTransHistory,
                    owner_account_id: txn?.owner_account_id,
                    BeneAccId: txn?.internal_account_id,
                    owner_account_bank_acc_no: txn?.owner_account_bank_acc_no,
                    internal_account_bank_acc_no:
                      txn?.internal_account_bank_acc_no,
                    internal_account_confidential:
                      modalType === "Confidential transaction"
                        ? txn?.confidential_transaction
                        : null,
                    onClose: closeTransactionHistory,
                  }}
                />
              )}
              {internalAccountDetailpop && (
                <div
                  className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
                  onClick={() => {
                    closeBeneAccountDetailModal();
                  }}
                >
                  <InternalAccountDetailsPopup
                    closeBeneAccountDetailModal={closeBeneAccountDetailModal}
                    bene_account_id={internalAccountID}
                    type={"bene_account_detail_modal"}
                    flowType={"internalAccount"}
                  />
                </div>
              )}

              {showDeclineModal && (
                <InternalTxnDeclinePopup
                  handleClose={closeDeclineModal}
                  txnId={internalTxnDetailID}
                  allTxnData={viewInternalTxnDetails}
                  updateAllTxn={updateAllAccounts}
                  addLifeCycleStatus={addLifeCycleStatus}
                  onRejectSuccess={() => {
                    if (isPopup) {
                      closeInternalTxnDetailModal();
                      window.location.reload();
                    }
                  }}
                />
              )}

              <div
                className={`w-full flex relative h-height-sm Qsmd:mt-margin-base lg:px-padding-sm ${isPopup ? "" : "Qsmd:pt-padding-xs mt-margin-lg Qsmd:mt-margin-base  "}`}
              >
                {internalTransactionsDetailsData?.transaction?.map(
                  (account) => (
                    <div
                      key={account.txn_id}
                      className={`w-width-full h-auto  pt-padding-base mt-margin-base lg:mt-margin-base Qmd:pt-padding-base ${
                        isPopup
                          ? ""
                          : "Qsmd:mt-margin-base mt-margin-lg Qmd:pt-padding-base lg:pt-padding-base"
                      }`}
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        maxWidth: "var(--max-content-width)",
                      }}
                    >
                      <div className="flex flex-col lg:flex-row mx-margin-md lg:mx-margin-base">
                        <div className="flex  my-margin-md Qlg:mt-margin-md mt-margin-sm w-width-full lg:w-width-md justify-between px-padding-base lg:px-padding-base relative">
                          <div className="flex flex-col mt-margin-xs lg:px-padding-sm relative">
                            <div className="flex  gap-x-gap-xs relative">
                              <div>
                                <TitleSubtitlePair
                                  title={`INR ${formatCurrency(account.total_amount)}`}
                                  titleColor="settled"
                                  subtitle="Amount"
                                  info={true}
                                  onClick={showAmountInfo}
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={true}
                                  variant="md"
                                />
                              </div>
                              {infoBox && (
                                <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
                                  <CommonInfoBox
                                    headerTitle="Amount Breakdown"
                                    headerFontColor="text-primary"
                                    headerFontWeight="semibold"
                                    textSize="font-md"
                                    onClosepop={closeModal}
                                    popupBgColor="primary-bg"
                                    transactionLabel="Transaction amount"
                                    transactionAmount={account.total_amount}
                                    finalAmountLabel="Amount credited"
                                    rows={[
                                      {
                                        label: "Amount debited",
                                        value: account.total_amount,
                                        operation: "add",
                                        icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,
                                      },
                                      {
                                        label: "Tax amount",
                                        value: account.tax_amount,
                                        operation: "add",
                                        icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,
                                      },
                                      {
                                        label: "Payment charge",
                                        value: account.payment_charge,
                                        operation: "add",
                                      },
                                    ]}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="lg:border-l border-b lg:border-b-border-base border-solid border-primary-bg lg:my-margin-md"></div>
                        <div className="flex justify-between items-center py-padding-md lg:py-padding-base w-width-full lg:w-width-md px-padding-base lg:px-padding-base">
                          <div className=" mt-margin-xs lg:p-padding-sm lg:ml-margin-sm ml-0">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={false}
                              title={account?.internal_account_name}
                              titleColor={"text-primary"}
                              subtitle={"Account name"}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                              textAlign="left"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="border-b-border border-primary-bg px-padding-button-l Qsmd:px-padding-base lg:ml-margin-sm mx-margin-md lg:mx-margin-base"></div>
                      <div className="relative lg:mx-margin-base mx-margin-sm">
                        <div className="flex flex-col justify-between lg:flex-row lg:gap-gap-base h-auto lg:h-auto w-width-full">
                          <div className="lg:w-tl-width-3 flex  pt-padding-sm lg:h-height-md justify-between lg:px-padding-base pl-padding-base lg:pl-padding-base">
                            <TitleSubtitlePair
                              isDisabled={isPopup ? true : false}
                              alignRight={false}
                              title={formatAccountNumber(
                                account?.owner_account_bank_acc_no,
                              )}
                              titleColor={"text-primary"}
                              subtitle={"Source account"}
                              onClick={() => {
                                if (isPopup) {
                                  actionRestricted();
                                  return;
                                }

                                if (services?.includes("VAccount")) {
                                  setOwnerDetailpop(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VAccount",
                                    },
                                  });
                                }
                              }}
                              info={false}
                              showArrow={true}
                              hoverOption={"white"}
                              isBold={false}
                              variant={"md"}
                            />
                            <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-md lg:mr-margin-md mr-margin-sm">
                              <CommonBankLogo
                                ifsc={account.owner_account_ifsc_code}
                                variant="big"
                                type="pill"
                              />
                            </div>
                          </div>

                          <div className="flex items-center gap-gap-sm justify-between lg:hidden mx-margin-sm lg:mx-margin-base">
                            <div className="w-width-md border-b border-primary-bg "></div>
                            <div className="w-icon-lg">
                              <img
                                src={ICONS?.ARROW_DOWN_BLUE_WHITE}
                                alt="arrowDownBlueWhite"
                              />
                            </div>
                            <div className="w-width-md border-b border-primary-bg "></div>
                          </div>

                          <div
                            className={`${
                              !(
                                internalTransactionsDetailsData?.transaction?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.confidential_transaction === "Y"
                              )
                                ? "lg:h-height-of-statistics-tab-line"
                                : ""
                            } border-r border-solid border-primary-bg my-margin-lg hidden lg:block mt-margin-md`}
                          ></div>
                          <div className="flex lg:pt-padding-sm w-width-full lg:w-width-md justify-between lg:h-height-md Qlg:mb-margin-base mb-margin-sm lg:pl-padding-base pl-padding-base lg:pr-padding-base pr-padding-base">
                            <div className="Qlg:pl-padding-sm pl-padding-base">
                              <TitleSubtitlePair
                                isDisabled={isPopup ? true : false}
                                alignRight={false}
                                title={formatAccountNumber(
                                  account?.internal_account_bank_acc_no,
                                )}
                                titleColor={"text-primary"}
                                subtitle={"Destination account"}
                                onClick={() => {
                                  if (isPopup) {
                                    actionRestricted();
                                    return;
                                  }
                                  if (services?.includes("IVAccount")) {
                                    setInternalAccDetailOpen(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "IVAccount",
                                      },
                                    });
                                  }
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-md lg:mr-margin-md mr-margin-sm">
                              <CommonBankLogo
                                ifsc={account?.internal_account_ifsc_code}
                                variant="big"
                                type="pill"
                              />
                            </div>
                          </div>
                          <div className="hidden lg:flex">
                            {hasConfidential &&
                            internalTransactionsDetailsData?.transaction?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.confidential_transaction === "Y" ? (
                              <div className="hidden lg:flex ">
                                <div className="border-b border-solid border-primary-bg">
                                  <TopNavSmallButton
                                    btnText={
                                      <>
                                        Confidential <br /> transactions
                                      </>
                                    }
                                    handleFunction={() => {
                                      if (isPopup) {
                                        actionRestricted();
                                      } else {
                                        openTransactionHistory();
                                        setModalType(
                                          "Confidential transaction",
                                        );
                                      }
                                    }}
                                    icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                                    enabledBgColor={"var(--primary-nav-act)"}
                                    enabledTextColor={"var(--text-primary)"}
                                    hoverOption="white"
                                    isDisabled={isPopup}
                                  />
                                </div>
                              </div>
                            ) : (
                              <div className="min-w-splitview-btn-width hidden lg:flex" />
                            )}
                          </div>
                        </div>
                        <div className="lg:flex justify-end items-center hidden z-z-index-content absolute top-[var(--ifsc-img-width)] w-width-md ml-margin-sm">
                          <img
                            src={ICONS?.ARROW_RIGHT_BLUE_WHITE}
                            className="h-icon-md my-margin-sm"
                            alt="Internal_Transaction_Arrow"
                          />
                        </div>
                      </div>
                      <div className="lg:border-l border-b lg:border-b-border-base border-solid border-primary-bg block lg:hidden mt-margin-base mx-margin-md lg:mx-margin-base"></div>
                      <div className="flex flex-col lg:flex-row mx-margin-md lg:mx-margin-base">
                        <div className="flex py-padding-md w-width-full lg:w-width-md lg:px-padding-base justify-between lg:mt-margin-xs lg:pt-padding-sm lg:pb-padding-md">
                          <div className="mt-margin-xs lg:px-padding-sm">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={false}
                              title={account?.owner_account_ifsc_code}
                              titleColor={"text-primary"}
                              subtitle={"IFSC code"}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>
                          <div className="mt-margin-xs lg:mr-margin-md">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={true}
                              title={account?.payment_method ?? "N/A"}
                              titleColor={"text-primary"}
                              subtitle={"Payment method"}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                              textAlign="right"
                            />
                          </div>
                        </div>
                        <div className="lg:border-l border-b lg:border-b-border-base border-solid border-primary-bg lg:mt-margin-md m-margin-base lg:mb-margin-md Qlg:mx-margin-base"></div>
                        <div className="w-width-full lg:w-width-md lg:px-padding-base py-padding-md lg:border-border-base border-primary-bg lg:py-padding-base flex justify-between">
                          <div
                            className={`box-with-confidential Qlg:w-width-xl justify-between gap-gap-md flex lg:pt-padding-sm lg:mt-margin-xs lg:pb-padding-md ${
                              hasConfidential &&
                              internalTransactionsDetailsData?.transaction?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.confidential_transaction === "Y"
                                ? "lg:w-width-full"
                                : ""
                            }`}
                          >
                            <div className="mt-margin-xs lg:ml-margin-md w-width-md">
                              <TitleSubtitlePair
                                isDisabled={false}
                                alignRight={false}
                                title={account?.internal_account_ifsc_code}
                                titleColor={"text-primary"}
                                subtitle={"IFSC code"}
                                info={false}
                                showArrow={false}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                          </div>

                          <div className="hidden lg:flex h-height-full">
                            <TopNavSmallButton
                              btnText={
                                <>
                                  {globalText.TRANSACTION}
                                  <br />
                                  {globalText.HISTORY.toLowerCase()}
                                </>
                              }
                              handleFunction={() => {
                                if (isPopup) {
                                  actionRestricted();
                                } else {
                                  openTransactionHistory();
                                  setModalType("Transaction history");
                                }
                              }}
                              icon={ICONS?.TRANSACTION_HISTORY}
                              enabledBgColor={"var(--primary-nav-act)"}
                              enabledTextColor={"var(--text-primary)"}
                              hoverOption="white"
                              isDisabled={isPopup}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                )}
              </div>

              {(isRejectedOrServiceMissing ||
                isPendingInternalTxn ||
                approvalNotPermitted) && (
                <div className="w-screen bg-primary-bg block lg:hidden">
                  <div className="flex flex-col w-width-full m-auto">
                    <div className="flex  w-width-full m-auto">
                      {/* Mobile  */}
                      <TimelineStatusBar
                        showMobile={true}
                        isLoading={loadingBox}
                        overrideAutoLoader
                        whichBtnClicked={
                          btnClicked?.[
                            viewInternalTxnDetails?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.txn_id
                          ] || "none"
                        }
                        approvalNotPossible={
                          networkError ||
                          errorMessage ||
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.message
                        }
                        approvalNotPossibleIcon={true}
                        handleApprovalNotPossibleBtn={() => {
                          if (
                            services?.includes("AInternalTxn") &&
                            checkInternalTransaction
                          ) {
                            handleRecreateDeclinedDetails(
                              viewInternalTxnDetails?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.txn_id,
                            );
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "AInternalTxn",
                              },
                            });
                          }
                        }}
                        isApprovalNotPossibleDisabled={false}
                        accountApprovalPending={
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.internal_account_approval_status === "pending" &&
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.lifecycle_status === "pending"
                        }
                        accountApprovalPendingSubHeader={
                          services?.includes("AInternalTxn")
                            ? "Account is not approved, approve account before approving transaction."
                            : "To approve the account, please contact the authorized person."
                        }
                        handleApprovalPendingBtn={() => {
                          if (
                            (services?.includes("IVAccount") &&
                              services?.includes("IAAccount")) ||
                            services?.includes("Admin")
                          ) {
                            setInternalAccountDetailpop(true);
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService:
                                  "IAAccount, IVAccount, Admin",
                              },
                            });
                          }
                        }}
                        furtherApprovalPending={isFurtherApprovalPending}
                        approvalNotPermitted={
                          approvalNotPermitted && !isFurtherApprovalPending
                        }
                        isApprovalPendingDisabled={
                          !services?.includes("AInternalTxn")
                        }
                        recreate={
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.lifecycle_status === "rejected"
                        }
                        recreateReason={
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.rejection_reason?.length >
                          RejectReasonLength.lengthOfDecline
                            ? viewInternalTxnDetails?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.rejection_reason.slice(
                                GlobalConfiguration.lengthCheckZero,
                                RejectReasonLength.lengthOfDecline,
                              ) + "..."
                            : viewInternalTxnDetails?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.rejection_reason
                        }
                        recreateBtnNeeded={
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.lifecycle_status === "rejected"
                        }
                        isRecreateDisabled={!hasCreateService}
                        handleRecreateBtn={() => {
                          if (hasCreateService) {
                            sessionStorage.setItem(
                              "recreate_int_txn_id",
                              JSON.stringify(
                                viewInternalTxnDetails?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.txn_id,
                              ),
                            );
                            navigate(
                              "/internal_transaction_dashboard/create_internal_transaction",
                              {
                                state: {
                                  txn_id:
                                    viewInternalTxnDetails?.[
                                      GlobalConfiguration.lengthCheckZero
                                    ]?.txn_id,
                                  type: "refactorFlow",
                                },
                              },
                            );
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: ["CInternalTxn"],
                              },
                            });
                          }
                        }}
                        pending={
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.internal_account_approval_status === "approved" &&
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.lifecycle_status === "pending" &&
                          !approvalNotPermitted
                        }
                        rejectMobClick={() => {
                          if (!services?.includes("AInternalTxn")) {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "AInternalTxn",
                              },
                            });
                            return;
                          }
                          setbtnClicked((prev) => ({
                            ...prev,
                            [viewInternalTxnDetails?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.txn_id]: "reject",
                          }));

                          handleDeclinedDetails(
                            viewInternalTxnDetails?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.txn_id,
                          );
                        }}
                        isRejectMobDisable={!checkInternalTransaction}
                        approveMobClick={() => {
                          if (!services?.includes("AInternalTxn")) {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "AInternalTxn",
                              },
                            });
                            return;
                          }
                          setbtnClicked((prev) => ({
                            ...prev,
                            [viewInternalTxnDetails?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.txn_id]: "approve",
                          }));
                          handleApproveInternalTransaction(
                            viewInternalTxnDetails?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.txn_id,
                          );
                        }}
                        isApproveMobDisable={!checkInternalTransaction}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="w-screen bg-primary-bg block lg:hidden">
                <div className="flex flex-col w-width-full m-auto">
                  <div className="flex flex-col w-width-full mt-margin-md ">
                    <div className="py-padding-sm px-padding-md text-font-sm text-text-primary text-left font-sans font-semibold bg-primary-card">
                      Quick Action
                    </div>
                    <div className="w-width-full flex flex-col items-center">
                      <div className="w-width-full flex ">
                        <TopNavLargeButton
                          btnText={
                            <>
                              {globalText.TRANSACTION}
                              <br />
                              {globalText.HISTORY.toLowerCase()}
                            </>
                          }
                          handleFunction={() => {
                            if (isPopup) {
                              actionRestricted();
                            } else {
                              openTransactionHistory();
                              setModalType("Transaction history");
                            }
                          }}
                          icon={ICONS?.TRANSACTION_HISTORY}
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary)"}
                          hoverOption="white"
                          isDisabled={isPopup}
                          fullWidthRequired={true}
                        />
                      </div>
                      {hasConfidential &&
                      internalTransactionsDetailsData?.transaction?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.confidential_transaction === "Y" ? (
                        <div className="border-t-primary-bg border-t-border w-width-full">
                          <TopNavLargeButton
                            btnText={
                              <>
                                Confidential <br /> transactions
                              </>
                            }
                            handleFunction={() => {
                              if (isPopup) {
                                actionRestricted();
                              } else {
                                openTransactionHistory();
                                setModalType("Confidential transaction");
                              }
                            }}
                            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary)"}
                            hoverOption="white"
                            isDisabled={isPopup}
                            fullWidthRequired={true}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {shouldShowBankingHoursAlert && (
              <div className="max-w-tab-width-normal w-full Qlg:mx-auto pt-padding-md px-padding-md Qlg:px-padding-base">
                <CommonAlertCard
                  title="Functioning outside banking hours"
                  texts="Transactions will be processed automatically during the next bank working day. Learn more"
                  highlightedText={["Learn more"]}
                  onHighlightedTextClick={(event, index) => {
                    if (index === 0) {
                      setShowBankingHoursPopup(true);
                    }
                  }}
                />
              </div>
            )}

            <div
              className={`txntimeline ${isPopup ? "w-width-full" : "w-screen"}`}
            >
              <div className="mt-margin-md w-width-full timeline_box max-w-tab-width-normal m-auto flex">
                <div
                  className={`bg-primary-card flex flex-col w-full lg:w-width-md mx-margin-md lg:mx-margin-base h-auto overflow-hidden relative rounded-bl-border-radius-md rounded-t-border-radius-md self-end ${
                    viewInternalTxnDetails?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.internal_account_approval_status === "approved" &&
                    viewInternalTxnDetails?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.lifecycle_status === "approved"
                      ? "rounded-br-border-radius-md"
                      : viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.internal_account_approval_status === "pending" &&
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.lifecycle_status === "approved"
                        ? "rounded-b-border-radius-md"
                        : viewInternalTxnDetails?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.lifecycle_status === "rejected"
                          ? ""
                          : "lg:rounded-br-none rounded-b-border-radius-md"
                  }`}
                >
                  <div
                    className={`flex flex-col w-full h-auto rounded-t-border-radius-md overflow-hidden relative ${
                      viewInternalTxnDetails?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.internal_account_approval_status === "approved" &&
                      viewInternalTxnDetails?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.lifecycle_status === "pending"
                        ? "rounded-bl-border-radius-md rounded-br-border-radius-md"
                        : "rounded-b-border-radius-md"
                    }`}
                  >
                    <div className="pt-px bg-primary-nav rounded-tl-border-radius-md px-padding-md rounded-tr-border-radius-md">
                      <p className="text-text-primary text-font-xs text-left font-semibold my-margin-sm">
                        Transaction Timeline
                      </p>
                      <div className="border-b border-primary-bg"></div>
                    </div>

                    <div ref={leftContentRef}>
                      <CommonTimeLineCard
                        logsData={viewInternalTxnDetails}
                        handleApprovalClick={handleTimelinePopup}
                        handleDistributionClick={handleDistributionClick}
                        showApprovalTimeline={showApprovalTimeline}
                        showDistributionTimeline={showDistributionTimeline}
                        showDistributionRightIcon={true}
                        showApprovalLeftIcon={true}
                        isDisabled={isPopup ? true : false}
                        cardType={"double"}
                      />
                    </div>
                  </div>
                </div>

                {(isRejectedOrServiceMissing ||
                  isPendingInternalTxn ||
                  approvalNotPermitted) && (
                  <div
                    className={`h-full lg:flex hidden mt-margin-xs ${
                      viewInternalTxnDetails?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.internal_account_approval_status === "pending" &&
                      viewInternalTxnDetails?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.lifecycle_status === "pending"
                        ? "w-width-md"
                        : "w-width-base"
                    }`}
                  >
                    <TimelineStatusBar
                      showMobile={false}
                      isLoading={loadingBox}
                      overrideAutoLoader
                      whichBtnClicked={
                        btnClicked?.[
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.txn_id
                        ] || "none"
                      }
                      requestApprove
                      approvalNotPossible={
                        networkError ||
                        errorMessage ||
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.message
                      }
                      approvalNotPossibleIcon={true}
                      handleApprovalNotPossibleBtn={() => {
                        if (
                          services?.includes("AInternalTxn") &&
                          checkInternalTransaction
                        ) {
                          handleRecreateDeclinedDetails(
                            viewInternalTxnDetails?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.txn_id,
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AInternalTxn",
                            },
                          });
                        }
                      }}
                      isApprovalNotPossibleDisabled={false}
                      accountApprovalPending={
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.internal_account_approval_status === "pending" &&
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.lifecycle_status === "pending"
                      }
                      accountApprovalPendingSubHeader={
                        services?.includes("AInternalTxn")
                          ? "Account is not approved, approve account before approving transaction."
                          : "To approve the account, please contact the authorized person."
                      }
                      handleApprovalPendingBtn={() => {
                        if (
                          (services?.includes("IVAccount") &&
                            services?.includes("IAAccount")) ||
                          services?.includes("Admin")
                        ) {
                          setInternalAccountDetailpop(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "IAAccount, IVAccount, Admin",
                            },
                          });
                        }
                      }}
                      isApprovalPendingDisabled={
                        !services?.includes("AInternalTxn")
                      }
                      furtherApprovalPending={isFurtherApprovalPending}
                      approvalNotPermitted={
                        approvalNotPermitted && !isFurtherApprovalPending
                      }
                      recreate={
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.lifecycle_status === "rejected"
                      }
                      recreateReason={
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.rejection_reason?.length >
                        RejectReasonLength.lengthOfDecline
                          ? viewInternalTxnDetails?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.rejection_reason.slice(
                              GlobalConfiguration.lengthCheckZero,
                              RejectReasonLength.lengthOfDecline,
                            ) + "..."
                          : viewInternalTxnDetails?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.rejection_reason
                      }
                      recreateBtnNeeded={
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.lifecycle_status === "rejected"
                      }
                      isRecreateDisabled={!hasCreateService}
                      handleRecreateBtn={() => {
                        if (hasCreateService) {
                          sessionStorage.setItem(
                            "recreate_int_txn_id",
                            JSON.stringify(
                              viewInternalTxnDetails?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.txn_id,
                            ),
                          );
                          navigate(
                            "/internal_transaction_dashboard/create_internal_transaction",
                            {
                              state: {
                                txn_id:
                                  viewInternalTxnDetails?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.txn_id,
                                type: "refactorFlow",
                              },
                            },
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: ["CInternalTxn"],
                            },
                          });
                        }
                      }}
                      pending={
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.internal_account_approval_status === "approved" &&
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.lifecycle_status === "pending" &&
                        !approvalNotPermitted
                      }
                      rejectClick={() => {
                        if (!services?.includes("AInternalTxn")) {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AInternalTxn",
                            },
                          });
                          return;
                        }
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.txn_id]: "Reject",
                        }));
                        handleDeclinedDetails(
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.txn_id,
                        );
                      }}
                      isRejectDisable={!checkInternalTransaction}
                      approveClick={() => {
                        if (!services?.includes("AInternalTxn")) {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AInternalTxn",
                            },
                          });
                          return;
                        }
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.txn_id]: "Approve",
                        }));
                        handleApproveInternalTransaction(
                          viewInternalTxnDetails?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.txn_id,
                        );
                      }}
                      isApproveDisable={!checkInternalTransaction}
                    />
                  </div>
                )}
              </div>

              <div
                className={`details-div-trans lg:pt-padding-base mb-margin-md ${
                  isPopup ? "w-width-full" : "w-screen"
                }`}
              >
                <div className="detail-section-trans h-auto m-auto max-w-tab-width-normal">
                  <div className="flex pt-padding-md Qsmd:pl-padding-md Qlg:pl-padding-base Qmd:ml-margin-base ml-margin-md mr-margin-md">
                    <div className="flex switch-tab-parent gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden">
                      <SwitcherTabs
                        initialActiveTab={
                          isPopup ? "additional_details" : "details"
                        }
                        tabs={[
                          {
                            label: "Details",
                            handler: toggleDetails,
                            key: "details",
                          },
                          {
                            label: "Additional details",
                            handler: toggleAdditionalDetails,
                            key: "additional_details",
                          },
                          {
                            label: "Labels",
                            handler: toggleLabels,
                            key: "assigned labels",
                          },
                        ]}
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      {viewInternalTxnDetails?.map((account) => {
                        let originItemList = [
                          {
                            content: `${account?.logs?.[0]?.first_name ?? ""} ${account?.logs?.[0]?.last_name ?? ""}`,
                            heading: "Created by",
                            type: "text",
                          },
                          {
                            content: formatDateViewAll(account?.created_on),
                            heading: "Created on",
                            type: "text",
                          },
                        ];

                        let settlementItemList = [];
                        if (
                          account?.distribution_lifecycle_status ===
                          "distribution_complete"
                        ) {
                          settlementItemList = [
                            {
                              content: account?.distribution_credited_at
                                ? ISO_DataFormatter(
                                    account?.distribution_credited_at,
                                  )
                                : "N/A",
                              heading: "Settled on",
                              type: "text",
                            },
                            {
                              content:
                                account?.distribution_settlement_id || "N/A",
                              heading: "Settlement ID",
                              type: "textWithButton",
                              iconArray: [
                                {
                                  icon:
                                    copiedField === "settlement_id"
                                      ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                      : ICONS.COPY,
                                  bgColor: "var(--text-primary)",
                                  title:
                                    copiedField === "settlement_id"
                                      ? "Copied"
                                      : "Copy to clipboard",
                                  onClick: (e) => {
                                    setCopiedField("settlement_id");
                                    navigator.clipboard.writeText(
                                      account.distribution_settlement_id,
                                    );
                                    setTimeout(() => {
                                      setCopiedField("");
                                    }, IntervalConfiguration.intervalMedium);
                                  },
                                },
                              ],
                            },
                          ];
                        }
                        let supportItemList = [
                          {
                            content: account.txn_id,
                            heading: "Transaction ID",
                            type: "textWithButton",
                            iconArray: [
                              {
                                icon:
                                  copiedField === "txn_id"
                                    ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                    : ICONS.COPY,
                                bgColor: "var(--text-primary)",
                                title:
                                  copiedField === "txn_id"
                                    ? "Copied"
                                    : "Copy to clipboard",
                                onClick: (e) => {
                                  setCopiedField("txn_id");
                                  navigator.clipboard.writeText(account.txn_id);
                                  setTimeout(() => {
                                    setCopiedField("");
                                  }, IntervalConfiguration.intervalMedium);
                                },
                              },
                            ],
                          },
                          ...(account?.distribution_id
                            ? [
                                {
                                  content: account.distribution_id,
                                  heading: "Distribution ID",
                                  type: "textWithButton",
                                  iconArray: [
                                    {
                                      icon:
                                        copiedField === "distribution_id"
                                          ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS.COPY,
                                      bgColor: "var(--text-primary)",
                                      title:
                                        copiedField === "distribution_id"
                                          ? "Copied"
                                          : "Copy to clipboard",
                                      onClick: (e) => {
                                        setCopiedField("distribution_id");
                                        navigator.clipboard.writeText(
                                          account.distribution_id,
                                        );
                                        setTimeout(() => {
                                          setCopiedField("");
                                        }, IntervalConfiguration.intervalMedium);
                                      },
                                    },
                                  ],
                                },
                              ]
                            : []),
                          ...(account?.distribution_identifier
                            ? [
                                {
                                  content: account.distribution_identifier,
                                  heading: "Distribution identifier",
                                  type: "textWithButton",
                                  iconArray: [
                                    {
                                      icon:
                                        copiedField ===
                                        "distribution_identifier"
                                          ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS.COPY,
                                      bgColor: "var(--text-primary)",
                                      title:
                                        copiedField ===
                                        "distribution_identifier"
                                          ? "Copied"
                                          : "Copy to clipboard",
                                      onClick: (e) => {
                                        setCopiedField(
                                          "distribution_identifier",
                                        );
                                        navigator.clipboard.writeText(
                                          account.distribution_identifier,
                                        );
                                        setTimeout(() => {
                                          setCopiedField("");
                                        }, IntervalConfiguration.intervalMedium);
                                      },
                                    },
                                  ],
                                },
                              ]
                            : []),
                        ];

                        return (
                          <div
                            className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base ${
                              account?.distribution_lifecycle_status ===
                              "distribution_complete"
                                ? "justify-between gap-gap-md"
                                : "gap-gap-md"
                            }`}
                          >
                            <CommonDetailCard
                              cardTitle="Origin Details"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={originItemList}
                            />

                            {account?.distribution_lifecycle_status ===
                              "distribution_complete" && (
                              <CommonDetailCard
                                cardTitle="Settlement Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={settlementItemList}
                              />
                            )}

                            <CommonDetailCard
                              cardTitle="Support Information"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={supportItemList}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <div className="flex flex-col lg:flex-row items-center Qmd:items-start gap-gap-md pb-padding-md text-text-primary mt-margin-md px-padding-md lg:px-padding-base">
                        <>
                          {validItems?.filter(
                            (item) =>
                              item.name !== "Hyperlink" &&
                              item.name !== "File" &&
                              item.name !== "Image",
                          ).length === GlobalConfiguration?.lengthCheckZero ? (
                            <div className="Qlg:w-details-card-lg w-width-full flex flex-row Qlg:flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md">
                              <div className="text-text-primary text-font-sm font-semibold">
                                Additional Details
                              </div>
                              <p className="text-text-secondary text-font-xs font-normal">
                                Additional details are not supported for the
                                selected category.
                              </p>
                            </div>
                          ) : (
                            <>
                              {(() => {
                                const filteredItems = validItems.filter(
                                  (item) =>
                                    item.data_type.toLowerCase() !==
                                      "hyperlink" &&
                                    item.data_type !== "File" &&
                                    item.data_type !== "Image" &&
                                    item.data_type !== "upload",
                                );

                                const midIndex = Math.ceil(
                                  filteredItems.length /
                                    GlobalConfiguration?.lengthCheckTwo,
                                );
                                const leftColumn = filteredItems.slice(
                                  GlobalConfiguration?.lengthCheckZero,
                                  midIndex,
                                );
                                const rightColumn =
                                  filteredItems.slice(midIndex);

                                const orderedItems = [];
                                for (
                                  let i = GlobalConfiguration?.lengthCheckZero;
                                  i < midIndex;
                                  i++
                                ) {
                                  if (leftColumn[i])
                                    orderedItems.push(leftColumn[i]);
                                  if (rightColumn[i])
                                    orderedItems.push(rightColumn[i]);
                                }

                                return (
                                  <CommonDetailCard
                                    cardTitle="Additional details"
                                    numCols={
                                      GlobalConfiguration?.lengthCheckTwo
                                    }
                                    variant="third"
                                    entries={orderedItems.map((subItem) => {
                                      switch (subItem.data_type) {
                                        case "toggle":
                                          return {
                                            content: subItem?.value
                                              ? "Yes"
                                              : "No",
                                            heading: subItem?.name,
                                            type: "text",
                                          };
                                        case "multi_select_list":
                                          return {
                                            content:
                                              Array.isArray(subItem?.value) &&
                                              subItem?.value?.length >
                                                GlobalConfiguration?.lengthCheckZero
                                                ? subItem.value.join(", ")
                                                : "Not given",
                                            heading: subItem?.name,
                                            type: "text",
                                          };
                                        case "date_range":
                                          return {
                                            content: subItem?.value?.start_date
                                              ? `${subItem.value.start_date} - ${subItem.value.end_date}`
                                              : "Not given",
                                            heading: "From date - To date",
                                            type: "text",
                                          };
                                        case "from_year_to_year":
                                          return {
                                            content: subItem?.value?.from
                                              ? `${subItem.value.from} - ${subItem.value.to}`
                                              : "Not given",
                                            heading: "From year - To year",
                                            type: "text",
                                          };
                                        default:
                                          return {
                                            content:
                                              subItem?.value ?? "Not given",
                                            heading: subItem?.name,
                                            type: "text",
                                          };
                                      }
                                    })}
                                  />
                                );
                              })()}
                            </>
                          )}
                        </>

                        {attachments.length >
                          GlobalConfiguration?.lengthCheckZero && (
                          <>
                            <CommonDetailCard
                              cardTitle="Attachments"
                              numCols={GlobalConfiguration.lengthCheckOne}
                              variant="third"
                              entries={attachments.map((obj, index) => {
                                switch (obj.data_type) {
                                  case "hyperlink":
                                    return {
                                      content: obj?.value ?? "#",
                                      heading: "URL",
                                      type: "link",
                                    };
                                  default: {
                                    const ob = obj?.value;
                                    const mt = (
                                      ob?.metadata?.mime_type ||
                                      "application/octet-stream"
                                    ).toLowerCase();

                                    const isImage = mt.startsWith("image/");

                                    return {
                                      content: {
                                        fileName: ob?.metadata?.filename,
                                        size: ob?.metadata?.size ?? "0",
                                        mimeType: mt,
                                        url: ob?.file_url,
                                        onUrlClick: () => {
                                          if (isImage) {
                                            setOpenImageUrl(true);
                                            setSelectedImage({
                                              name: ob?.metadata?.filename,
                                              url: ob?.file_url,
                                            });
                                          } else {
                                            window
                                              .open(ob?.file_url, "_blank")
                                              ?.focus();
                                          }
                                        },
                                      },
                                      heading: isImage ? "Image" : "File",
                                      type: isImage ? "image" : "file",
                                    };
                                  }
                                }
                              })}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckTwo && (
                    <div className={animationClass}>
                      <div className="mt-margin-md">
                        <CommonContainerCard
                          header="Assigned Labels"
                          subheader={
                            "These will be used to generate statistics for the associated transactions."
                          }
                          iconIsDisabled={isPopup}
                          icon={ICONS?.EDIT}
                          handleFunction={(e) => {
                            e.stopPropagation();
                            if (
                              !(
                                services?.includes("ALabel") &&
                                services?.includes("RLabel")
                              )
                            ) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                              return;
                            }
                            if (isPopup) {
                              actionRestricted();
                              return;
                            }
                            setShowLabelsPopup(true);
                          }}
                        >
                          <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length ? (
                              <>
                                {labelDetails?.map((item, index) => (
                                  <Chips
                                    key={index}
                                    txtChip={item}
                                    enabledBgColor="var(--primary-nav)"
                                    disableIcon={true}
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      return;
                                    }}
                                    enabledTextColor="var(--text-primary)"
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                Not assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InternalTransactionDetails;
